import styles from "./LoadingComponent.module.css"
function LoadingComponent(){
    return <span className={styles.loader}></span>
}
export default LoadingComponent